import { pathBuilder } from 'config/paths/index';

export const root = '/v2/admin/activity';
export default pathBuilder(root);
